export enum ConsultationTreatmentTypes {
  Acne = 'acne',
  BacterialVaginosis = 'bacterial_vaginosis',
  Nurse = 'nurse',
  StarfishStd = 'starfish_std',
  Std = 'std',
  StdPrevention = 'std_prevention',
  Uti = 'uti',
  YeastInfection = 'yeast_infection',
  Hsv = 'hsv',
  Metformin = 'metformin',
  Glp1 = 'glp_1',
  Glp1Renewal = 'glp_1_renewal',
  MaleBv = 'male_bv',
  Zofran = 'zofran',
  Hemorrhoids = 'hemorrhoids',
  Ed = 'ed',
  Trt = 'trt',
  Peptide = 'peptide',
  PeptideRenewal = 'peptide_renewal',
  TrtRenewal = 'trt_renewal',
  HairLoss = 'hair_loss',
  Rash = 'rash',
  FemaleCondom = 'female_condom',
  PeptideWs = 'peptide_ws',
  PeptideWsRenewal = 'peptide_ws_renewal',
  PeptideGs = 'peptide_gs',
  PeptideGsRenewal = 'peptide_gs_renewal',
  PeptideBpc157 = 'peptide_bpc_157',
  PeptideBpc157Renewal = 'peptide_bpc_157_renewal',
  PeptideGhkCu = 'peptide_ghk_cu',
  PeptideGhkCuRenewal = 'peptide_ghk_cu_renewal',
  PeptideTb500 = 'peptide_tb_500',
  PeptideTb500Renewal = 'peptide_tb_500_renewal',
  PeptideCjc1295 = 'peptide_cjc_1295',
  PeptideCjc1295Renewal = 'peptide_cjc_1295_renewal',
  PeptidePt141 = 'peptide_pt_141',
  PeptidePt141Renewal = 'peptide_pt_141_renewal',
}
